import { Card, Divider, Paper, Typography, Box, CardContent } from '@mui/material'
import React from 'react'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { baseUrl } from '../services/api-services';
import PhotoIcon from '@mui/icons-material/Photo';
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
        ...theme.applyStyles('dark', {
            backgroundColor: '#308fe8',
        }),
    },
}));
export function TimelineItem({ date, time, label, value, isLast, unit }) {
    return (
        <Box display="flex" alignItems="start" position="relative" marginBottom={4}>
            {/* Left Section: Date and Time */}
            <Box
                width="15%"
                textAlign="right"

                sx={{
                    display: { lg: "flex", xs: "none" },
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    paddingRight: 2,
                }}
            >
                <Typography variant="body2" color="icon">
                    {date}
                </Typography>
                <Typography variant="body2" color="icon">
                    {time}
                </Typography>
            </Box>

            {/* Icon Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="10%"
                position="relative"
            >
                <Box
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        padding: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <AccessibilityIcon color="success" />
                </Box>

                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translateX(-50%)",
                        height: "calc(100% + 150px)",
                        backgroundColor: "#cfcfcf",
                        zIndex: -1,
                    }}
                />

            </Box>

            {/* Right Section: Card with Content */}
            <Paper flex={1} sx={{ padding: 2, minHeight: "200px", position: "relative" }} className="w-full">

                <Typography variant="body1" color="text.primary" fontWeight="bold">
                    {label}
                </Typography>
                <Typography variant="h6" color="text.secondary" mt={0.5}>
                    {value}{unit}
                </Typography>
                <Box
                    display={{ xs: "block", lg: "none" }} // Display for small screens
                    sx={{
                        position: "absolute",
                        bottom: 5,
                        left: 15,
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="icon">
                        {date}
                    </Typography>
                    <Typography variant="body2" color="icon">
                        {time}
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
}
export function UserTimeLine({ status = "Pending", price = 0, date = "N/A", time = "N/A", title = "Program", enrollOndate = new Date().toISOString(), duration = 0 }) {
    const completedOn = new Date(enrollOndate);
    completedOn.setDate(completedOn.getDate() + parseInt(duration, 10));

    const oneDay = 24 * 60 * 60 * 1000;
    const today = new Date();
    const remainingDay =
        completedOn.getTime() > today.getTime()
            ? Math.round((completedOn.getTime() - today.getTime()) / oneDay)
            : 0;

    const formatDate = (date) =>
        new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });

    return (
        <Box display="flex" alignItems="start" position="relative" marginBottom={4}>
            {/* Left Section: Date and Time */}
            <Box
                width="15%"
                textAlign="right"
                sx={{
                    display: { lg: "flex", xs: "none" },
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    paddingRight: 2,
                }}
            >
                <Typography variant="body2" color="icon">
                    {date}
                </Typography>
                <Typography variant="body2" color="icon">
                    {time}
                </Typography>
            </Box>

            {/* Icon Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="10%"
                position="relative"
            >
                <Box
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        padding: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    aria-label="Credit Card Icon"
                >
                    <CreditCardIcon color="success" />
                </Box>

                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translateX(-50%)",
                        height: "calc(100% + 250px)",
                        backgroundColor: "#cfcfcf",
                        zIndex: -1,
                    }}
                />

            </Box>

            {/* Right Section: Card with Content */}
            <Paper flex={1} sx={{ padding: 2, minHeight: "250px", marginLeft: 3, width: "100%", position: 'relative' }}>
                <Box display='flex' flexDirection='column' gap={1}>
                    <Typography>WeightWonder™ {title}</Typography>
                    <Typography variant='body2'>
                        {formatDate(enrollOndate)} - {formatDate(completedOn)}
                    </Typography>
                    <Typography className={remainingDay === 0 ? "text-[green]" : "text-[#facc15]"}>{remainingDay == '0' ? 'Completed' : 'In Progress'}</Typography>
                    <BorderLinearProgress variant="determinate" value={remainingDay == '0' ? '100' : duration - remainingDay} />
                    <Typography color='success' className='flex justify-end'>{remainingDay} Remaining</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                    {/* Price with Success Color */}
                    <Typography variant='body2' display='flex' gap={1}>
                        Program Fee:  <Typography sx={{ color: "success.main", fontWeight: "bold" }}> ₹{price}</Typography>
                    </Typography>

                    {/* Status with Conditional Styling */}
                    <Typography variant='body2' display='flex' gap={1}>
                        Fee Status:<Typography
                            sx={{
                                color: status.toLowerCase() === "due" ? "error.main" : "success.main",
                                fontWeight: "bold",
                                textTransform: "capitalize",
                            }}
                        >{status}</Typography>
                    </Typography>
                </Box>
                <Box
                    display={{ xs: "block", lg: "none" }} // Display for small screens
                    sx={{
                        position: "absolute",
                        bottom: 5,
                        left: 15,
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="icon">
                        {date}
                    </Typography>
                    <Typography variant="body2" color="icon">
                        {time}
                    </Typography>
                </Box>
            </Paper>
        </Box>
    );
}

export function GalaryTimeLine({ image, date, time }) {
    return (
        <Box display="flex" alignItems="start" position="relative" marginBottom={4}>
            {/* Left Section: Date and Time */}
            <Box
                width="15%"
                textAlign="right"
                sx={{
                    display: { lg: "flex", xs: "none" },
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    padding: 2,
                    marginTop: 2
                }}
            >
                <Typography variant="body2" color="icon">
                    {date}
                </Typography>
                <Typography variant="body2" color="icon">
                    {time}
                </Typography>
            </Box>

            {/* Icon Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="10%"
                position="relative"
            >
                <Box
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        padding: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <PhotoIcon color="success" />
                </Box>
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translateX(-50%)",
                        height: "calc(100% + 300px)",
                        backgroundColor: "#cfcfcf",
                        zIndex: -1,
                    }}
                />
            </Box>

            {/* Right Section: Card with Content */}
            <Paper
                sx={{
                    padding: 2,
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    position: 'relative',
                    width: '100%',
                }}
            >
                <Typography textAlign='start' fontWeight={500}>Progress Photo</Typography>
                <Box
                    sx={{
                        flexGrow: 1, // Allows the image to take up available space
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={`${baseUrl}/Uploads/gallery/download/${image}`}
                        alt="gallery"
                        style={{
                            width: "100%", // Ensures the image takes up full width of its container
                            height: "100%", // Ensures the image takes up full height of its container
                            objectFit: "contain", // Maintains the aspect ratio and ensures full visibility
                        }}
                    />
                </Box>

                <Box
                    display={{ xs: "block", lg: "none" }}
                    sx={{
                        position: "absolute",
                        bottom: 5,
                        left: 15,
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="icon">
                        {date}
                    </Typography>
                    <Typography variant="body2" color="icon">
                        {time}
                    </Typography>
                </Box>
            </Paper>


        </Box>
    )
}

export function PaymentTimeLine({ amount, paymentMode, title, date, time }) {
    return (
        <Box display="flex" alignItems="start" position="relative" marginBottom={4}>
            {/* Left Section: Date and Time */}
            <Box
                width="15%"
                textAlign="right"
                sx={{
                    display: { lg: "flex", xs: "none" },
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    paddingRight: 2,
                }}
            >
                <Typography variant="body2" color="icon">
                    {date}
                </Typography>
                <Typography variant="body2" color="icon">
                    {time}
                </Typography>
            </Box>
            {/* Icon Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="10%"
                position="relative"
            >
                <Box
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: "50%",
                        padding: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <AttachMoneyIcon color="success" />
                </Box>

                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translateX(-50%)",
                        height: "calc(100% + 150px)",
                        backgroundColor: "#cfcfcf",
                        zIndex: -1,
                    }}
                />

            </Box>

            {/* Right Section: Card with Content */}
            <Paper flex={1} sx={{ padding: 2, minHeight: "150px", marginLeft: 3, position: 'relative' }} className='w-full'>
                <Typography> Amount</Typography>
                <Box display='flex' gap={1} marginBottom={3}>
                    <Typography fontWeight='bold'>₹{amount}</Typography>     <Typography className=' text-[#808090] font-semibold'>{paymentMode}</Typography> </Box>
                WeightWonder™ {title}

                <Box
                    display={{ xs: "block", lg: "none" }} // Display for small screens
                    sx={{
                        position: "absolute",
                        bottom: 5,
                        left: 15,
                        width: "100%",
                    }}
                >
                    <Typography variant="body2" color="icon">
                        {date}
                    </Typography>
                    <Typography variant="body2" color="icon">
                        {time}
                    </Typography>
                </Box>
            </Paper>
        </Box>
    )
}
